/**
 * Bloks custom: IT-Recht policy page table wrapping
 * --------------------------------------------------
 * Wraps tables inside .shopify-policy__body in scroll containers,
 * mirroring assets/rte-formatter.js behavior on regular pages.
 *
 * Search the codebase for "bloks-policy-pages" to find all related files.
 * To tweak table behavior: edit this file only.
 */

/**
 * Wraps a table in a scrollable container.
 * @param {HTMLTableElement} table
 */
function wrapPolicyTable(table) {
  if (table.parentElement?.classList.contains('rte-table-wrapper')) return;

  const wrapper = document.createElement('div');
  wrapper.classList.add('rte-table-wrapper');
  const parent = table.parentNode;
  if (parent) {
    parent.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  }
}

/**
 * Formats all tables inside Shopify policy page bodies.
 */
function formatPolicyTables() {
  document.querySelectorAll('.shopify-policy__body table').forEach(wrapPolicyTable);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', formatPolicyTables);
} else {
  formatPolicyTables();
}
